import { useEffect } from 'react';
import { CmtyBaseTable } from '../CmtyBaseTable';
import { CTMY_CATG_BANK, CTMY_CATG_BANK_NAME, CTMY_CATG_BANK_URL, CTMY_CATG_BANK_URL_NAME } from '../CmtyConstant'

export function CmtyBank() {
    useEffect(() => {
        localStorage.setItem("CTMY_CATG", CTMY_CATG_BANK)
        localStorage.setItem("CTMY_CATG_URL", CTMY_CATG_BANK_URL)
        localStorage.setItem("CTMY_CATG_NAME", CTMY_CATG_BANK_NAME)
    }, []);

    return (
        <div>
            <main class="page lanidng-page">
                <section>
                    <div class="container" style={{paddingTop:'100px', marginTop: '10px', marginBottom: '10px'}}>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><span>커뮤니티</span></li>
                            <li class="breadcrumb-item"><span>은행</span></li>
                        </ol>
                    </div>
                    <div class="container">
                        <CmtyBaseTable cmtyCatg={CTMY_CATG_BANK} cmtyCatgName={CTMY_CATG_BANK_NAME} 
                            cmtyCatgUrl={CTMY_CATG_BANK_URL} cmtyCatgUrlName={CTMY_CATG_BANK_URL_NAME}/>
                    </div>
                </section>
            </main>
        </div>
    );
}